import moment from 'moment'
import { useRecoilState } from "recoil";
import { trendZoomState } from "../../../plugins/recoil";

function HeartRateDraw({ data, boxInfo, style, handleSelectBoxTimeInfo, handleDoubleClick, patientDischargeMarker }) {
    const [trendZoom] = useRecoilState(trendZoomState)

    return (        
        <div style={{ width: `${boxInfo.width}px`, height: `${boxInfo.height}px` }} className="flex flex-wrap">
            { 
                (trendZoom == '60m' || trendZoom == '40m' || trendZoom == '15m') && 
                <div className={`flex items-end relative w-full ${style}`} onClick={handleSelectBoxTimeInfo} style={{fontFamily: 'Roboto'}} onDoubleClick={() => handleDoubleClick('hr',data[0].timestamp)}>
                    {                        
                        data.map((hrData,_) => {                                                        
                            const time = moment(hrData.timestamp).startOf("second").format();                            
                            return (
                                <div key={_} className="relative flex flex-col flex-wrap items-center justify-end flex-1 h-full">
                                    <p className="text-[8px] font-normal mb-[5px] text-[#fff]">{hrData.value ? hrData.value : 0}</p>                                    
                                    {/* <div className='hidden'>{time}</div> */}
                                    {/* {
                                        selectTimeInfo && moment(hrData.timestamp).isSame(moment(selectTimeInfo)) && (
                                            <div className="absolute w-[2px] h-full bg-[#3864FF]"></div>
                                        )
                                    } */}
                                    {
                                        patientDischargeMarker.map((marker) => {                                                                
                                            return (
                                                moment(hrData.timestamp).isSame(moment(marker.formattedTime)) ? (      
                                                    // <div className="absolute w-[2px] h-full bg-[#3864FF]"></div>
                                                    <div className="">
                                                        <div
                                                            className="absolute"
                                                            style={{
                                                                top: '0px',
                                                                right: '3px',
                                                                width: '0',
                                                                height: '0',
                                                                transform: 'rotate(-90deg)',
                                                                borderBottom: '6px solid #CECECE',
                                                                borderLeft: '6px solid transparent'
                                                            }}
                                                        />
                                                        
                                                        <div
                                                            className="absolute"
                                                            style={{
                                                                top: '0px',
                                                                right: '3px',
                                                                width: '1px',
                                                                height: '100%', // 위아래 삼각형 제외
                                                                backgroundColor: '#CECECE'
                                                            }}
                                                        />
                                                        
                                                        <div
                                                            className="absolute"
                                                            style={{
                                                                bottom: '0px',
                                                                right: '3px',
                                                                width: '0',
                                                                height: '0',
                                                                transform: 'rotate(90deg)',
                                                                borderTop: '6px solid #CECECE',
                                                                borderLeft: '6px solid transparent'
                                                            }}
                                                        />
                                                    </div>
                                                ) : null
                                            )
                                        })
                                    }

                                </div>
                            )
                        })
                    }
                </div>
            }                
        </div>
    );
}

export default HeartRateDraw;
